import { Component } from '@angular/core';
import { PermissionService } from 'projects/cross-study-portal-lib/src/lib/services/permission.service';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';

@Component({
  selector: 'mcp-apps-menu',
  templateUrl: './apps-menu.component.html',
  styleUrls: ['./apps-menu.component.scss'],
})
export class AppsMenuComponent {
  constructor(
    private permissionService: PermissionService,
    private context: ContextService,
    private window: Window,
  ) { }

  get shouldShowMenu(): boolean {
    if (this.hasCtmsAccess) {
      return true;
    }

    return false;
  }

  get hasCtmsAccess(): boolean {
    return this.context.instance.ctmsEnabled && this.permissionService.hasCtmsAccessPermission();
  }

  onCtmsSelect(): void {
    if (this.context.instance.ctmsUrl) {
      this.window.location.href = this.context.instance.ctmsUrl;
    }
  }
}
